import React from 'react'
import NumberFormat from 'react-number-format'
import { useTranslation } from 'react-i18next'
import { ACCOUNT_KEYS } from '../../utils/translation-constants'

export default function AccountDisplay({ currentAccountDetail = {} }) {
  const { t } = useTranslation()
  return (
    <div className='d-flex source-account-section'>
      <div className='image'></div>
      <div>
        <label>{t(ACCOUNT_KEYS.EXPENSE_KEYS.SOURCE_ACCOUNT_NUMBER)}</label>
        <h3>{currentAccountDetail?.accountNo}</h3>
        <p>
          {t(ACCOUNT_KEYS.ACCOUNT_SELECT_KEYS.AVAILABLE_BALANCE)}:{' '}
          <span style={{ marginRight: 5 }}>{currentAccountDetail?.currency}</span>
          <NumberFormat
            // value={currentAccountDetail?.avlBal}
            value={currentAccountDetail?.avlBal}
            displayType={'text'}
            thousandSeparator={true}
            prefix={''}
            fixedDecimalScale={true}
            decimalScale={2}
            allowEmptyFormatting
          />
        </p>
      </div>
    </div>
  )
}
